import {defineMessages} from 'react-intl';

export default defineMessages({
  message: {
    defaultMessage: 'No content available in this language',
    id: 'LandingPage.NoItemsMessage.Message',
  },
});
